import { Injectable } from '@angular/core';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';

/**
 * declare Jquery
 * */
declare let $: any;

@Injectable({ providedIn: 'root' })
export class ThemeService {
  theme: string = '';
  cssContent: string = '';
  variableFields: any = {};
  
  constructor(
    private localStorageService: LocalStorageService,
  ) {
    // $.get(`/assets/scss/_variables_theme.scss`, (cssContent) => {
    //   this.cssContent = cssContent.split(':root {')[1];
    //   const variableFields = this.cssContent.split('}')[0].split(';');
    //   variableFields.forEach((field) => {
    //     const text = field.replace(' ', '').replace('\r\n', '').replace(`   --`, '').split(':');
    //     if (!text[0] || !text[1]) { 
    //       return;
    //     }
    //     this.variableFields[text[0]] = text[1].replace(' ', '');
    //   })
    //   this.localStorageService.store('variable_theme', this.variableFields);
    //   this.changeTheme(this.localStorageService.retrieve('theme'));
    // });
  }

  changeTheme(theme) {
    theme = theme || 'default';
    if (this.theme) {
      $('body').removeClass(this.theme + '-theme');
      this.theme = theme;
    }
    this.theme = theme;
    $('body').addClass(this.theme + '-theme');
    
    if (theme === 'dynamic') {
      let mainColor = '', color1 = '', color2 = '';
      this.variableFields[`${'dynamic-theme-main-color'}`] = this.localStorageService.retrieve('dynamic-theme-main-color') || this.variableFields[`${'dynamic-theme-main-color'}`];
      this.variableFields[`${'dynamic-theme-color'}`] = this.localStorageService.retrieve('dynamic-theme-color') || this.variableFields[`${'dynamic-theme-color'}`];
      this.variableFields[`${'dynamic-theme-color-2'}`] = this.localStorageService.retrieve('dynamic-theme-color-2') || this.variableFields[`${'dynamic-theme-color-2'}`];
      this.variableFields[`${'dynamic-theme-color-3'}`] = this.localStorageService.retrieve('dynamic-theme-color-3') || this.variableFields[`${'dynamic-theme-color-3'}`];
      this.variableFields[`${'dynamic-theme-color-4'}`] = this.localStorageService.retrieve('dynamic-theme-color-4') || this.variableFields[`${'dynamic-theme-color-4'}`];
      this.variableFields[`${'dynamic-theme-color-5'}`] = this.localStorageService.retrieve('dynamic-theme-color-5') || this.variableFields[`${'dynamic-theme-color-5'}`];
      document.documentElement.style.setProperty(`--dynamic-theme-main-color`, this.variableFields[`${'dynamic-theme-main-color'}`]);
      document.documentElement.style.setProperty(`--dynamic-theme-color`, this.variableFields[`${'dynamic-theme-color'}`]);
      document.documentElement.style.setProperty(`--dynamic-theme-color-2`, this.variableFields[`${'dynamic-theme-color-2'}`]);
      document.documentElement.style.setProperty(`--dynamic-theme-color-3`, this.variableFields[`${'dynamic-theme-color-3'}`]);
      document.documentElement.style.setProperty(`--dynamic-theme-color-4`, this.variableFields[`${'dynamic-theme-color-4'}`]);
      document.documentElement.style.setProperty(`--dynamic-theme-color-5`, this.variableFields[`${'dynamic-theme-color-5'}`]);
    }
  }
 
}